import { render, staticRenderFns } from "./PageRecommend.vue?vue&type=template&id=15f951e2&scoped=true"
import script from "./PageRecommend.vue?vue&type=script&lang=js"
export * from "./PageRecommend.vue?vue&type=script&lang=js"
import style0 from "./PageRecommend.vue?vue&type=style&index=0&id=15f951e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f951e2",
  null
  
)

export default component.exports